var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmallFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st5{fill:#003750;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M409.62,157.38c-0.55-1.02-1.22-2.01-2.04-2.91l-0.24-0.28l-0.26-0.26l-0.12-0.13l-85.33-85.33l-0.28-0.27 l-0.29-0.27l-0.1-0.09c-0.9-0.82-1.89-1.49-2.91-2.04c-2.15-1.16-4.6-1.8-7.19-1.8H115.81c-8.41,0-15.24,6.83-15.24,15.24v353.52 c0,8.41,6.83,15.24,15.24,15.24h280.38c8.41,0,15.24-6.83,15.24-15.24V164.57C411.43,161.97,410.78,159.52,409.62,157.38 L409.62,157.38z M295.62,164.57c0,8.41,6.83,15.24,15.24,15.24h70.1v237.71h-249.9V94.48h164.57V164.57z M326.1,149.33h33.3 l-33.3-33.3V149.33z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallFile);
export default __webpack_public_path__ + "static/media/small-file.a4b6fe94f0c41d613c60a70f7f6220fb.svg";
export { ForwardRef as ReactComponent };